export default class SnappingManager {
  constructor(threshold = 70) {
    this.threshold = threshold;
    this.snappableObjects = [];
    this._width = 0;
  }

  setWidth(width) {
    this._width = width;
  }

  addSnappableObject(object) {
    this.snappableObjects.push(object);
  }

  removeSnappableObject(object) {
    const index = this.snappableObjects.indexOf(object);
    if (index > -1) {
      this.snappableObjects.splice(index, 1);
    }
  }

  clearSnappableObjects() {
    this.snappableObjects = [];
  }

  findSnapTarget(position) {
    for (const object of this.snappableObjects) {
      const q = object.position();
      if (Math.hypot(q.x - position.x, q.y - position.y) < this.threshold) {
        return object;
      }
      if (Math.hypot(q.x + this.width - position.x, q.y - position.y) < this.threshold) {
        return object;
      }
      if (Math.hypot(q.x - this.width - position.x, q.y - position.y) < this.threshold) {
        return object;
      }
    }
    return undefined;
  }
}

